import { useLocation } from "react-router-dom";
import { useQuery } from "~/hooks/useQuery";

export type MembershipPaymentAction = "extend" | "payment" | "resubscribe";

export const useGetMembershipPaymentAction = (): MembershipPaymentAction => {
  const location = useLocation();
  const isResubscribe = !!location.state?.resubscribe;
  const extendParams = useQuery().get("extend");
  const isExtend = !!location.state?.extend || !!extendParams;

  if (isResubscribe) return "resubscribe";
  if (isExtend) return "extend";

  return "payment";
};
